<template>
  <div class="group-root" :class="{ root }">
    <div class="name" :class="{ root }" @click="toggleOpen" :title="open ? 'Ocultar subgrupos' : 'Ver subgrupos'">
      <i v-if="!open && group.subGroups.length > 0" class="fas fa-users-class" :class="{ open }"></i>
      <i v-else class="fas fa-user-friends" :class="{ open }"></i>
      <span @click.stop="$emit('select', group)"
            title="Mostrar usuarios de este grupo y sus subgrupos"
            :class="{ selected: selectedId === group.id}">{{ group.name }}
      </span>
    </div>
    <div class="subgroups" v-if="open && group.subGroups && group.subGroups.length">
      <UserGroupItem v-for="item in group.subGroups" :key="item.id" :group="item" @select="$emit('select', $event)" :selectedId="selectedId"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TrackingUserGroup } from '@/types/Tracking'

@Component({
  name: 'UserGroupItem'
})
export default class UserGroupItem extends Vue {
  @Prop({ required: true })
  group: TrackingUserGroup

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: false })
  opened: boolean

  @Prop({ required: false, default: 0 })
  selectedId: number

  open = false

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }
}
</script>
